import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Index from './pages/index/index';
import { useEffect } from 'react';
import React from 'react';
import Contact from './pages/contact';
import Creators from './pages/creator/creators';
import CreatorProfile from './pages/creator/creator-profile';
import CreatorProfileEdit from './pages/creator/creator-profile-edit';
import Login from './pages/auth/login';
import Signup from './pages/auth/signup';
import ResetPassword from './pages/auth/reset-password';
import Accept from './pages/special/accept';
import Error from './pages/special/error';
import Thankyou from './pages/special/thankyou';
import Terms from './pages/terms';
import ItemDetail from './pages/explore/item-detail';
import ExploreOne from './pages/explore/explore-one';
import Wallet from './pages/wallet';
import PrivacyPolicy from './pages/privacy-policy';
import LockScreen from './pages/auth/lock-screen';
import ScrollToTop from './components/scroll-top';
import CookieConsentModal from './components/CookieConsentModal';
import CookiePolicyPage from './components/CookiePolicyPage';
import PrivateRoute from './components/PrivateRoute';
import ForgotPassword from './pages/auth/ForgotPassword';  // Страница запроса сброса пароля
import ResetPassword2 from './pages/auth/ResetPassword'; 
import Cookies from 'js-cookie';
import { loadGTM, loadGA } from './components/analyticsLoader';

function App() {
  useEffect(() => {
    document.documentElement.setAttribute("dir", "ltr");
    document.documentElement.classList.add('dark');
    document.body.classList.add('font-urbanist', 'text-base', 'text-black', 'dark:text-white', 'dark:bg-slate-900');

  });
  
  useEffect(() => {
    const consent = Cookies.get('cookie_consent');
    if (
      consent === 'all' ||
      (consent === 'custom' &&
       Cookies.get('cookie_preferences') &&
       JSON.parse(Cookies.get('cookie_preferences')).analytics)
    ) {
      loadGTM();
      loadGA();
    }
  }, []);
  return (
    <BrowserRouter>
      <ScrollToTop />
      <CookieConsentModal />
      <Routes>
        <Route path="/" element={<Index />}  />
        <Route path='/explore-one' element={<ExploreOne />} />
        <Route path='/wallet' element={<Wallet />} />
        <Route path='/cookiepolicy' element={<CookiePolicyPage />} />
        <Route path='/item-detail' element={<ItemDetail />} />
        <Route path='/item-detail/:username/:contract/:identifier' element={<ItemDetail />} />
        <Route path='/privacy' element={<PrivacyPolicy />} />
        <Route path='/terms' element={<Terms />} />
        <Route path='/error' element={<Error />} />
        <Route path='/thankyou' element={<Thankyou />} />
        <Route path='/login' element={<Login />} />
        <Route path='/signup' element={<Signup />} />
        <Route path='/reset-pass' element={<ResetPassword />} />
        <Route path='/lock-screen' element={<LockScreen />} />
        <Route path="/forgot-password" element={<ForgotPassword />} /> 
        <Route path="/reset-password/:token" element={<ResetPassword2 />} />
        <Route path='/accept' element={<Accept />} />
        {/* Защищенные маршруты для профиля пользователя */}
        <Route
          path='/creator-profile/:username'
          element={
            <PrivateRoute>
              <CreatorProfile />
            </PrivateRoute>
          }
        />
        <Route
          path='/creator-profile-edit/:id'
          element={
            <PrivateRoute>
              <CreatorProfileEdit />
            </PrivateRoute>
          }
        />
        <Route path='/creators' element={<Creators />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Error />} />
      </Routes>
    
    </BrowserRouter>
  );
}

export default App;
